import styled from '@emotion/styled';
import { CommonBG, CommonBorder, ControlFilldBG, CommonText, LegendStatusBG } from 'ui/theme/Color';
import { SVGIcon } from 'components/buttons/IconSVG';

export const ProcessBarWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 12px;
  position: relative;
  width: 100%;
  height: 40px;
  &.mt24 {
    margin-top: 12px;
  }
  &.mgT {
    margin-top: 24px;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 3px;
  background: ${CommonBorder.Strong}; //기본 라인색
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  &:before {
    content: '';
    clear: both;
    display: inline-block;
    width: 2px;
    height: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    background: ${CommonBorder.Strong}; //좌측 시작 라인
  }
  &:after {
    content: '';
    clear: both;
    display: inline-block;
    width: 2px;
    height: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    background: ${CommonBorder.Strong}; //우측 끝 라인
  }
`;

export const ProcessStepBox = styled.div`
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  position: relative;
  z-index: 2;
  &:first-child {
    &:before {
      opacity: 0;
    }
  }
  &:before {
    content: '';
    clear: both;
    display: inline-block;
    width: 50%;
    height: 40px;
    position: absolute;
    top: 0;
    left: 0;
    background: ${CommonBG.Basic}; //남은 프로세스 라인의 우측
    opacity: 0.6;
  }
  &:after {
    content: '';
    clear: both;
    display: inline-block;
    width: 50%;
    height: 40px;
    position: absolute;
    top: 0;
    left: 50%;
    background: ${CommonBG.Basic}; //남은 프로세스 라인의 좌측
    opacity: 0.6;
  }
  &:nth-last-of-type(2) {
    &.done {
      & + div {
        &:before {
          opacity: 1;
        }
      }
    }
  }
  &.done {
    &:after {
      opacity: 0;
    }
    & > div {
      span {
        background: ${CommonBorder.Stronger}; //동그라미순번 배경색 - 종료된
        color: ${CommonBorder.Stronger}; //동그라미순번 글자색(배경이랑 동일하게 해야 체크가 보임) - 숫자색상
        border: none;
        position: relative;
        &:before {
          content: '';
          clear: both;
          display: inline-block;
          width: 12px;
          height: 12px;
          position: absolute;
          top: calc(50% - 6px);
          left: calc(50% - 6px);
          background: ${CommonText.Inverse}; //체크색
          -webkit-mask: ${SVGIcon.IcoCheck};
          mask-image: ${SVGIcon.IcoCheck};
        }
      }
      div {
        color: ${CommonBorder.Stronger}; // 종료된 상태 글자색
      }
    }
    & + div {
      &:before {
        opacity: 0;
      }
    }
  }
  &.now {
    & > div {
      span {
        background: ${CommonBG.Primary}; //현재 상태 동그라미 배경색
        position: relative;
        border: none;
        color: ${CommonText.Inverse}; //현재 상태 동그라미 색
      }
      div {
        color: ${CommonBG.Primary}; //현재 상태 글자색
      }
    }
  }

  &.disable {
    & > div {
      span {
        border: 1px solid ${CommonText.Lighter}; //진행전 상태동그라미 배경색
        color: ${CommonText.Lighter};
      }
      div {
        pointer-events: none;
        color: ${CommonText.Lighter}; // 이게 좌측(진행전) 상태 글자색
      }
    }
  }
`;

export const StepBox = styled.div`
  padding: 0 11px;
  z-index: 3;
  background: ${CommonBG.Basic}; //글자 배경색
`;

export const ProcessStep = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 8px;
`;

export const ProcessNum = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid ${CommonBorder.Strong};
  color: ${CommonText.Light};
`;

export const ProcessText = styled.div`
  padding-left: 8px;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 700;
  white-space: nowrap;
  //color: #00bb00;
`;

export const SubStep = styled.ol`
  display: inline-flex;
  margin-left: 12px;
  height: 39px;
  align-items: center;
  padding: 0px 12px;
  background: ${CommonBG.Deeper};
  li {
    list-style: decimal;
    font-size: 15px;
    font-weight: 700;
    margin: 8px 36px 8px 18px;
    position: relative;
    color: ${CommonText.Lighter};
    &:after {
      content: '';
      clear: both;
      display: block;
      width: 36px;
      height: 39px;
      position: absolute;
      right: -36px;
      top: -8px;
      background: ${CommonBorder.Stronger};
      -webkit-mask: ${SVGIcon.IcoLineChevronDouble};
      mask-image: ${SVGIcon.IcoLineChevronDouble};
      mask-position: center center;
      mask-size: 18px 20px;
      mask-repeat: no-repeat;
    }
    &:last-child {
      margin: 8px 0px 8px 20px;
      &:after {
        content: '';
        display: none;
      }
    }
    &.now {
      color: ${CommonText.Primary};
    }
    &.done {
      color: ${CommonText.Light};
    }
  }
  &.subPer {
    list-style: none;
    background: none;
    position: relative;
    li {
      position: static;
      list-style: none;
      margin-left: 0;
      margin-right: 0;
      strong {
        margin-right: 6px;
      }
      > span {
        font-size: 13px;
        color: ${CommonText.Light};
        background: none;
      }
      > div {
        position: absolute;
        top: 0;
        left: 4px;
        right: 4px;
        background: ${CommonBG.Deeper};
        z-index: -1;
        > span {
          display: block;
          height: 38px;
          background: ${ControlFilldBG.PrimaryHover};
          opacity: 0.2;
        }
      }
      &:after {
        height: 5px;
        background: none;
      }
      &:first-child {
        color: ${CommonText.Primary};
        border-radius: 50%;
        padding: 4px 4px 4px 0;
      }
      &:nth-child(2) {
        padding-left: 2px;
        font-weight: normal;
        color: ${CommonText.Light};
        em {
          font-weight: bold;
          color: ${CommonText.Primary};
        }
      }
      &:nth-child(3) {
        padding-left: 12px;
        color: ${CommonText.Error};
      }
    }
  }
`;

export const StatusText = styled.div`
  font-size: 12px;
  font-weight: 700;
  padding-left: 12px;
  padding-right: 12px;
  font-size: 12px;
  background: #fff;
  &::before,
  &::after {
    content: '';
    clear: both;
    display: inline-block;
    width: 2px;
    height: 14px;
    position: absolute;
    top: -5px;
    left: 0;
  }
  &::after {
    left: auto;
    right: -2px;
  }
`;

export const StatusBox = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  transition: width 0.3s ease;
`;

export const ProgressBarWrapper = styled.div`
  height: 4px;
  width: 100%;
  border-radius: 4px;
  margin-top: -6px;
  z-index: 3;
  position: absolute;
  display: flex;
  > div {
    &:last-child {
      > div {
        &::after {
          right: 0;
        }
      }
    }
  }

  //신규개선
  .status_1 {
    background: #fca9bffc;
    > div {
      color: #fca9bffc;
      &::before,
      &::after {
        background: #fca9bffc;
      }
    }
  }
  //설비변경점
  .status_2 {
    background: #adcefffc;
    > div {
      color: #77aaf7fc;
      &::before,
      &::after {
        background: #adcefffc;
      }
    }
  }
  //수평전개
  .status_3 {
    background-color: #a897df;
    > div {
      color: #a897df;
      &::before,
      &::after {
        background: #a897df;
      }
      &::after {
        background: #a897df;
      }
    }
  }
`;
